<template>
  <div :class="login_box_class" class="login-box">
    <div class="el-aside">
      <div></div>
      <div>
        <div class="aside-title">微信扫码登录</div>
        <div v-if="
          url && url != 'request is too requently, please later try again'
        " id="login_container" class="aside-img-no">
          <img :src="url" alt="" />
        </div>
        <div v-else class="aside-img" @click="flush"></div>
        <div v-if="snapshot" class="aside-title" style="color: red">
          请在手机右下角授权
        </div>
      </div>
      <div class="aside-bottom">
        <a v-if="service" href="javaScript:;" class="zhuc" @click="goBack">店铺登录</a>
        <a v-else href="javaScript:;" class="zhuc" @click="goService">服务商登录</a>
        <a href="javaScript:;" class="zhuc" @click="goDownLoad">资源下载</a>
      </div>
    </div>
    <div class="el-right">
      <div class="right-title login-log">欢迎登录</div>
      <div class="login-log">
        <div class="handoff">
          <div @click="WxLogin" :class="handoff == true ? 'login-checked-account' : 'login-account'">
            个人登录
          </div>
          <div @click="AccountLogin" :class="handoff == false ? 'login-checked-wx' : 'login-wx'">
            {{ service ? "服务商登录" : "店铺登录" }}
          </div>
        </div>
        <!-- 用户名 -->
        <el-form :rules="loginFormRules" ref="loginFormRef" label-width="80px" class="login-form" :model="loginForm"
          v-show="!handoff" :style="'top:125px'">
          <!-- <el-form-item prop="account_type" label="类型:">
            <el-radio-group v-model="loginForm.account_type" size="mini">
              <el-radio-button label="service">服务商id</el-radio-button>
              <el-radio-button label="account">服务商账号</el-radio-button>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item prop="account_no" label="账号:">
            <el-input v-model="loginForm.account_no" placeholder="请输入账号:" hide-required-asterisk="false"></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item prop="pass_word" label="密码:">
            <el-input v-model="loginForm.pass_word" placeholder="请输入密码:" show-password></el-input>
          </el-form-item>
          <!-- RSAid -->
          <!-- 按钮部分  店铺登录、服务商登录-->
          <el-form-item class="btns">
            <el-button type="warning" @click="loginDeep">
              <slot></slot>
            </el-button>
          </el-form-item>
        </el-form>
        <div v-show="handoff">
          <el-form :rules="loginFormRules" ref="loginFormRef" label-width="80px" class="login-form" :model="loginForm"
            v-show="handoff" style="top: 105px">
            <el-form-item prop="account_type" label="类型:">
              <el-radio-group v-model="loginForm.account_type" size="mini">
                <el-radio-button label="account_no">账号</el-radio-button>
                <el-radio-button label="mobile_no">手机号</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="account_no" label="账号:">
              <el-input v-model="loginForm.account_no" placeholder="请输入账号:" hide-required-asterisk="false"></el-input>
            </el-form-item>
            <!-- 密码 -->
            <el-form-item prop="pass_word" label="密码:">
              <el-input v-model="loginForm.pass_word" placeholder="请输入密码:" show-password></el-input>
            </el-form-item>
            <!-- RSAid -->
            <!-- 按钮部分 -->
            <el-form-item class="btns">
              <el-button type="primary" @click="login">个人登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import {mapState,mapGetters,mapMutations,mapActions} from 'vuex'
import { mapMutations } from "vuex";
/* eslint-disable */
import { wxbaseurl, GetDateTime } from "@/api/common.js";
import { wxGetAcToken } from "@/api/wxService.js";
import {
  ServiceProviderLogin,
  accountLogin,
  merchantLogin,
  generateAccessTokenUrl,
} from "@/api/login";
export default {
  name: "login",
  inject: ["showDialog"],
  props: {
    service: Boolean,
  },
  data() {
    return {
      //返回的code
      code: "",
      timmer1: null,
      snapshot: false, //扫码下方红色提示
      url: "",
      loginForm: {
        account_no: "",
        pass_word: "",
        account_type: "account_no",
      },
      radio: 1,
      login_box_class: "",
      // 微信登录/账号登录
      handoff: false,
      //TODO: 这个是什么参数
      createTimmer_token: "",
      // 这是表单的验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        account_type: [
          { required: true, message: "请选择账号类型", trigger: "blur" },
        ],
        account_no: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max: 16, message: "应为 3 到 16 个字符", trigger: "blur" },
        ],
        // 验证密码是否合法
        pass_word: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  beforeDestroy() {
    clearInterval(this.timmer1);
    this.timmer1 = null;
  },
  mounted() {
    if (
      localStorage.getItem("merchant_id") &&
      localStorage.getItem("pass_word")
    ) {
      this.loginForm.account_no = localStorage.getItem("merchant_id");
      this.loginForm.pass_word = localStorage.getItem("pass_word");
    } else if (
      localStorage.getItem("service_no") &&
      localStorage.getItem("pass_word")
    ) {
      this.loginForm.account_no = localStorage.getItem("service_no");
      this.loginForm.pass_word = localStorage.getItem("pass_word");
    }
    this.flush();
    console.log(window.location.pathname);
    let url = window.location.pathname;
    if (url == "/login" || url == "/servicerlogin") {
      localStorage.removeItem("access_token");
      localStorage.removeItem("expire_time");
      localStorage.removeItem("token_type");
    }
  },
  beforeMount() {
    var resolution = window.screen.height * window.screen.width;
    if (resolution <= 700 * 900) {
      this.login_box_class = "login-box-small";
    }
    if (resolution > 700 * 900 && resolution < 1400 * 900) {
      this.login_box_class = "login-box-middle";
    }
    if (resolution > 1400 * 900) {
      this.login_box_class = "login-box-large";
    }
  },
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS"]),
    ...mapMutations("token", ["UPDATETOKENS", "SHOWDIALOG"]),
    dialogSureClick() { },
    /**
     * 更新定时器，重新获取登录二维码
     */
    async flush() {
      this.snapshot = false;
      clearInterval(this.timmer1);
      this.timmer1 = null;
      await this.getWxLoginUrl();
    },
    /**
     * 第一步 获取二维码
     */
    async getWxLoginUrl() {
      //判断此时所在的页面 如果不在login 或者是 servicerlogin 页面 不用继续执行
      if (
        this.$route.path != "/login" &&
        this.$route.path != "/servicerlogin"
      ) {
        clearInterval(that.timmer1);
        that.timmer1 = null;
        return;
      }
      var that = this;
      try {
        //获取微信接口需要的ticket
        const wxurl = await generateAccessTokenUrl();
        if (this.testR(wxurl) && wxurl.data && wxurl.data.resp_data && wxurl.data.resp_data.ticket) {
          this.$nextTick(() => {
            that.url = `${wxbaseurl}/cgi-bin/showqrcode?ticket=${wxurl.data.resp_data.ticket}`;
          });
          that.createTimmer();
          try {
            const accloginres = await wxGetAcToken(wxurl.data.resp_data.code);
            console.log("accloginres登录成功", accloginres);
            //登录成功
            if (that.testR(accloginres)) {
              that.snapshot = false;
              that.UPDATETOKENS(accloginres.data.resp_data.access_token);
              localStorage.setItem(
                "access_token",
                accloginres.data.resp_data.access_token
              );
              localStorage.setItem(
                "expire_time",
                accloginres.data.resp_data.expire_time
              );
              localStorage.setItem("token_type", "account");
              if (accloginres.data.resp_data.account_id) {
                localStorage.setItem(
                  "account_id",
                  accloginres.data.resp_data.account_id
                );
              }

              localStorage.setItem("gettoken_type", "scan");
              clearInterval(that.timmer1);
              that.timmer1 = null;
              //判断扫码登录服务商还是店铺
              if (that.service) {
                localStorage.setItem("login_type", "service");
              } else {
                localStorage.setItem("login_type", "merchant");
              }
              //调用父组件方法 选择管理的店铺或供应商
              that.showDialog(true);
              that.url = "";
              that.snapshot = false;
            } else {
              clearInterval(that.timmer1);
              that.timmer1 = null;
              that.url = "";
              that.snapshot = false;
            }
          } catch (e) { }
        } else {
          that.url = "";
          that.snapshot = false;
          clearInterval(that.timmer1);
          that.timmer1 = null;
          if (wxurl.data && wxurl.data.resp_data && wxurl.data.resp_data.errmsg) this.warnMessage(wxurl.data.resp_data.errmsg);
        }
        return;
      } catch (e) {
        console.log("获取微信登录二维码错误------------", e);
        this.warnMessage(e);
        this.url = "";
        this.snapshot = false;
        clearInterval(this.timmer1);
        this.timmer1 = null;
      }
    },
    /**
     * 创建定时器
     */
    async createTimmer(counts = 0) {
      var that = this;
      var count = counts;
      this.timmer1 = setInterval(() => {
        //控制循环次数  一分钟之后重新请求
        if (count > 60) {
          that.warnMessage("扫码或授权超时！");
          that.url = "";
          that.snapshot = false;
          clearInterval(that.timmer1);
          that.timmer1 = null;
          return;
        }
        count++;
      }, 2000);
    },
    resetLoginForm() {
      this.loginForm = {};
      this.$refs.loginFormRef.resetFields();
    },
    /**
     * 用户登录
     */
    async login() {
      // return;
      this.$refs.loginFormRef.validate(async (vaild) => {
        if (vaild) {
          const pass_word = await this.$encrypt(
            this.loginForm.pass_word,
            "pass_word"
          );
          var obj = {
            account_type: this.loginForm.account_type,
            [this.loginForm.account_type]: this.loginForm.account_no,
            pass_word,
          };
          const acount_login = await accountLogin(obj);
          // console.log("用户登录：", acount_login);
          //用户登录服务商
          if (this.testR(acount_login) && this.service) {
            if (acount_login.data.resp_data.access_token) {
              this.UPDATETOKENS(acount_login.data.resp_data.access_token);
              localStorage.setItem(
                "access_token",
                acount_login.data.resp_data.access_token
              );
              if (acount_login.data.resp_data.account_id) {
                localStorage.setItem(
                  "account_id",
                  acount_login.data.resp_data.account_id
                );
              }
              localStorage.setItem("token_type", "account");
              //注意用于判断登录的键
              localStorage.setItem("login_type", "service");
              localStorage.setItem("pass_word", this.loginForm.pass_word);
              localStorage.setItem(
                "expire_time",
                acount_login.data.resp_data.expire_time
              );
              this.showDialog(true);
            }
            //用户登录店铺
          } else if (this.testR(acount_login) && !this.service) {
            this.UPDATETOKENS(acount_login.data.resp_data.access_token);
            localStorage.setItem(
              "access_token",
              acount_login.data.resp_data.access_token
            );
            if (acount_login.data.resp_data.account_id) {
              localStorage.setItem(
                "account_id",
                acount_login.data.resp_data.account_id
              );
            }

            localStorage.setItem("token_type", "account");

            //注意用于判断登录的键
            localStorage.setItem("login_type", "merchant");
            localStorage.setItem("pass_word", this.loginForm.pass_word);
            localStorage.setItem(
              "expire_time",
              acount_login.data.resp_data.expire_time
            );
            this.showDialog(true);
          }
        } else {
          this.warnMessage("根据提示完成信息填写");
        }
      });
    },
    /**
     * 店铺账号，服务商账号登录
     */
    loginDeep() {
      console.log("点击的公路");
      this.$refs.loginFormRef.validate(async (vaild) => {
        //使用正式环境
        // localStorage.setItem("service_id", "123");
        if (vaild) {
          //服务商登录
          if (this.service) {
            try {
              const pass_word = await this.$encrypt(
                this.loginForm.pass_word,
                "pass_word"
              );
              var obj = {
                service_no: this.loginForm.account_no,
                pass_word,
              };
              const serverlogin_res = await ServiceProviderLogin(obj);
              // console.log("服务商登录：", serverlogin_res);
              if (this.testR(serverlogin_res)) {
                if (serverlogin_res.data.resp_data.access_token) {
                  localStorage.setItem(
                    "access_token",
                    serverlogin_res.data.resp_data.access_token
                  );
                  localStorage.setItem("service_no", this.loginForm.account_no);
                  localStorage.setItem("token_type", "service");
                  localStorage.setItem("pass_word", this.loginForm.pass_word);
                  localStorage.setItem(
                    "expire_time",
                    serverlogin_res.data.resp_data.expire_time
                  );
                  this.successMessage("服务商系统登录成功！！！");
                  clearInterval(this.timmer1);
                  this.timmer1 = null;
                  this.UPDATETOKENS(
                    serverlogin_res.data.resp_data.access_token
                  );
                  this.UPDATEMENUTABS("/welcome");
                  this.$router.push("/welcome");
                }
              }
            } catch (e) {
              this.$message.error(JSON.stringify(e));
            }
            return;
          } else {
            //店铺登录
            try {
              const pass_word = await this.$encrypt(
                this.loginForm.pass_word,
                "pass_word"
              );
              var obj = {
                merchant_id: this.loginForm.account_no,
                pass_word,
              };
              // 4975772599 123 5675808427
              //TODO: 密码错误的时候 result_code SUCCESS result_msg "商户ID或密码错误"
              //console.log("开始登录");
              const merchantlogin_res = await merchantLogin(obj);
              //console.log("店铺登录返回值：", merchantlogin_res);
              if (this.testR(merchantlogin_res)) {
                localStorage.setItem(
                  "access_token",
                  merchantlogin_res.data.resp_data.access_token
                );
                localStorage.setItem("merchant_id", this.loginForm.account_no);
                localStorage.setItem("token_type", "merchant");
                localStorage.setItem("pass_word", this.loginForm.pass_word);
                localStorage.setItem(
                  "expire_time",
                  merchantlogin_res.data.resp_data.expire_time
                );
                this.successMessage("店铺系统登录成功！！！");
                clearInterval(this.timmer1);
                this.timmer1 = null;
                this.UPDATETOKENS(
                  merchantlogin_res.data.resp_data.access_token
                );
                this.UPDATEMENUTABS("/welcome");
                this.$router.push("/welcome");
              }
            } catch (e) {
              console.log("错误出错：", e);
              this.$message.error(JSON.stringify(e));
            }
          }
        } else {
          this.warnMessage("根据提示完成信息填写");
        }
      });
    },
    /* anew() {
      this.reload();
    }, */
    goBack() {
      clearInterval(this.timmer1);
      this.timmer1 = null;
      this.UPDATEMENUTABS("/login");
      this.$router.push("/login");
    },
    zhucePeople() {
      clearInterval(this.timmer1);
      this.timmer1 = null;
      this.UPDATEMENUTABS("/register");
      this.$router.push("/register");
    },
    //TODO: 切换到个人登录
    async WxLogin() {
      //服务商页面
      /* if (this.service) {//TODO:服务商用户登录
        this.warnMessage("服务商暂不支持用户账号登录！");
        return;
      } */
      this.handoff = true;
    },
    AccountLogin() {
      // this.warnMessage("暂不支持账号登录")
      this.handoff = false;
      clearInterval(this.timmer1);
      this.timmer1 = null;
    },
    /**
     * 跳转到服务商登录界面
     */
    goService() {
      clearInterval(this.timmer1);
      this.timmer1 = null;
      this.UPDATEMENUTABS("/servicerlogin");
      this.$router.push("/servicerlogin");
    },
    /**
     * 跳转到下载界面
     * goDownLoad
     */
    goDownLoad() {
      clearInterval(this.timmer1);
      this.timmer1 = null;
      this.UPDATEMENUTABS("/download");
      this.$router.push("/download");
    },
  },
};
</script>
<style scoped lang="less">
.el-form-item {
  margin-bottom: 20px;
}

.login-box {
  width: 600px;
  height: 350px;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.3, 1.3);
  display: flex;
}

.login-box-large {
  transform: translate(-50%, -50%) scale(1.3, 1.3);
}

.login-box-small {
  transform: translate(-50%, -50%) scale(0.7, 0.7);
}

.login-box-middle {
  transform: translate(-50%, -50%) scale(0.85, 0.85);
}

.login-log {
  /* text-align: center; */
  color: dimgrey;
}

.zhuc {
  font-size: 16px;
  color: #fff;
  text-decoration: none;
  height: 30px;
}

.zhuc:hover {
  text-decoration: underline;
}

.btns {
  display: flex;
  justify-content: end;
}

.login-form {
  position: absolute;
  top: 125px;
  /* width: 100%; */
  padding: 0 25px;
  box-sizing: border-box;
}

.el-aside {
  display: inline-block;
  background-color: rgba(0, 105, 255, 0.603);
  width: 250px;
  height: 350px;
  border-radius: 10px 0 0 10px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .aside-img-no {
    width: 150px;
    height: 150px;

    img {
      width: 150px;
      height: 150px;
    }
  }

  .aside-img {
    width: 150px;
    height: 150px;

    img {
      width: 150px;
      height: 150px;
    }
  }

  .aside-img::before {
    position: absolute;
    content: "点击刷新";
    // display: inline-block;
    width: 150px;
    height: 150px;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    text-align: center;
    line-height: 9;
    cursor: pointer;
  }

  // padding-bottom: 20px;
  .el-form-left {
    height: 30px;
    text-align: center;
  }

  .aside-bottom {
    height: auto;
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;
  }

  .aside-title {
    color: #fff;
    margin-bottom: 10px;
  }
}

.el-right {
  width: 350px;
  height: 350px;
  display: inline-block;

  .right-title {
    width: 100%;
    height: 60px;
    // background-color: #fff;
    font-size: 24px;
    padding: 10px;
    font-weight: 700;
  }

  /* background-color:pink; */
}

.handoff {
  display: inline-block;
  height: 50px;
  width: 50%;
  position: absolute;
  top: 50px;
  left: 280px;
  font-size: 12px;
  text-align: center;
  line-height: 1.7;
  font-size: 20px;
}

.login-account {
  display: inline-block;
  width: 50%;
  height: 30px;
  border-right: 2px solid #77696c;
  cursor: pointer;
}

.login-wx {
  display: inline-block;
  width: 50%;
  height: 30px;
  cursor: pointer;
}

.login-checked-account {
  display: inline-block;
  width: 50%;
  height: 30px;
  color: #696969;
  font-weight: 700;
  border-right: 2px solid #77696c;
  cursor: pointer;
}

.login-checked-wx {
  display: inline-block;
  width: 50%;
  height: 30px;
  color: #696969;
  font-weight: 700;
  cursor: pointer;
}

.img-wx {
  margin-top: 90px;
  margin-left: 90px;
}

.img-bottom {
  margin-left: 44px;
  text-align: center;
}

.anew {
  text-align: center;
  position: absolute;
  margin-top: 90px;
  margin-left: 90px;
  top: 20px;
  /* transform: translate(0, 0, 0, -50%); */
  line-height: 13;
  background-color: rgba(142, 142, 142, 0.99);
  cursor: pointer;
}
</style>
